import React from 'react';

export const Calendar: React.FC<React.SVGProps<SVGSVGElement>> = ({ width, height, color }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width || '1em'} height={height || '1em'} viewBox="0 0 24 24">
        <path fillRule='evenodd' fill={color || 'currentColor'} d="M20 8V5h-2v1h-2V5H8v1H6V5H4v3h16Zm0 2H4v10h16V10Zm-2-7h2a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h2V2h2v1h8V2h2v1Z" />
    </svg>
);
